import { ReactNode, useReducer } from "react";

import { DispatchContext, initialState, reducer, StateContext } from "./reducer";

export function CoachmarksProvider({ children }: { children: ReactNode }) {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
        </StateContext.Provider>
    );
}
